$(document).on("turbolinks:load", () => {
  function updateOrganizationOptions(documentTypes, eventTarget) {
    let form = $(eventTarget.form);
    let element = $(eventTarget);
    let currentValues = element.val() || [];
    const allPossibleOrganizations = $("#parties-array").data("organizations");

    const selector = form.find(".organizations_selector");
    const selectedOrganizations = selector.val();

    let restrictedRoleIds = [];
    documentTypes.forEach((document_type) => {
      if (currentValues.includes(`${document_type.id}`)) {
        restrictedRoleIds = restrictedRoleIds.concat(document_type.restricted_role_ids);
      }
    });
    const organizationSelectOptions = allPossibleOrganizations.filter(
      (x) => !restrictedRoleIds.includes(x[2])
    );
    selector.find("option").remove();
    organizationSelectOptions.forEach((object) => {
      selector.append(`<option value="${object[0]}">${object[1]}</option>`);
    });
    selector.val(selectedOrganizations);
  }

  function handleSelectorDisabling(documentTypes, eventTarget, level) {
    let selectorClassName = `.${level}`;
    let form = $(eventTarget.form);
    let element = $(eventTarget);
    let currentValues = element.val() || [];
    let selector;

    if (form.hasClass("new-doc-form")) {
      selector = element.parents("fieldset").find(selectorClassName);
    } else {
      selector = form.find(selectorClassName);
    }

    if (
      !documentTypes
        .filter((x) => x[level])
        .map((x) => x.id.toString())
        .some((r) => currentValues.indexOf(r) >= 0)
    ) {
      selector.val("");
      selector.prop("disabled", true);
      if (!selector.hasClass("non-update-select2")) {
        selector.select2();
      }
    } else {
      selector.prop("disabled", false);
    }
  }

  function updateDocumentSelectors(event) {
    let element = event.currentTarget;
    const documentTypes = $("#document-types-array").data("documentTypes");

    handleSelectorDisabling(documentTypes, element, "booking_level");
    handleSelectorDisabling(documentTypes, element, "container_level");
    updateOrganizationOptions(documentTypes, element);
  }

  $(document).on("change", ".document_types_selector", updateDocumentSelectors);
});
